	jQuery("#submitsss").click(function(){
      var lfname=$('#lfname').val();
      var lemail=$('#lemail').val();
      var lphone=$('#lphone').val();
        var v = grecaptcha.getResponse();
    if(v.length == 0)
    {
        document.getElementById('captcha').innerHTML="You can't leave Captcha Code empty";
        return false;
    }
    else
    {
       //  document.getElementById('captcha').innerHTML="Captcha completed";
        //return true; 
    }
      if (lfname == "") {
      $(".errorf").show();
      return false;
      }
      var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
if (filter.test(lemail)) {
// alert(1);
}
else
  { $(".errore").show();
    return false;}
       if (lphone == "") {
      $(".erroree").show();
      return false;
      }
  $.ajax({
              url: 'https://laybyshop.com.au/api/laybuyleadsubmit',
              type: 'GET',
               data: { 'lfname' : lfname,
                      'lemail' : lemail,
                      'lphone' : lphone,
                     },
              success: function(response) {
                console.log(response);
                if(response!=1){
                  $(".step1").hide();
                  $(".step2").show();
                }
                
                else{
                  document.getElementById('captcha1').innerHTML="Email id Already used!!";
                }
                //window.location.href = 'https://laybyshop.com/pages/thank-you';
            }
          });
      return false;
});